import React from 'react'
import { motion } from 'framer-motion'
import Check from 'images/inline/spot-the-diff/check.svg'
import Error from 'images/inline/spot-the-diff/error.svg'
import withStyles from '@mui/styles/withStyles';
import CircularProgress from '@mui/material/CircularProgress'

export const OrderImage = ({
  backgroundNumber,
  isDropped,
  isWrongAnswer,
  isCorrectAnswer,
  checkingMatches = true,
  draggableCard,
  isEditorial,
}) => {
  const dropEffect = {
    dropped: {
      bottom: 4, // Moves to top-left corner
      right: 4,
      transition: {
        type: 'spring',
        damping: 20,
        duration: 3,
      },
    },
  }

  const iconStyle = {
    display: 'flex',
    width: '24px',
    height: '24px',
    background: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    position: 'absolute',
    zIndex: 3,
    transition: 'all 0.3s',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  }

  const SpinnerAdornment = withStyles({})(props => (
    <CircularProgress className={props.classes.spinner} size={20} />
  ))

  const gameTypeBackgroundColor = isEditorial ? 'black' : 'white'
  const gameTypeColor = isEditorial ? 'white' : 'black'

  return (
    backgroundNumber && (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          overflow: 'hidden',
          alignItems: 'center',
          borderRadius: '8px',
          border: `2px solid ${gameTypeBackgroundColor}`,
        }}
      >
        <motion.div
          style={{
            width: '100%', // The dropped card takes 50% of the slot's size
            height: '100%',
            zIndex: 2, // On top of the background
          }}
          initial="initial"
          animate={isDropped ? 'dropped' : 'initial'}
          variants={dropEffect}
        >
          {draggableCard}
          {isWrongAnswer && (
            <div style={{ ...iconStyle, backgroundColor: 'red' }}>
              <Error />
            </div>
          )}
          {isCorrectAnswer && (
            <div style={{ ...iconStyle, backgroundColor: 'green' }}>
              <Check />
            </div>
          )}
          {checkingMatches && (
            <div
              style={{
                ...iconStyle,
                backgroundColor: 'white',
                padding: '4px',
                width: 'unset',
                height: 'unset',
              }}
            >
              <SpinnerAdornment />
            </div>
          )}
        </motion.div>
        <div
          style={{
            color: gameTypeColor,
            fontSize: '1rem',
            textAlign: 'center',
            width: '100%',
            zIndex: 3,
            fontWeight: 'bold',
            margin: 0,
            backgroundColor: gameTypeBackgroundColor,
          }}
        >
          {backgroundNumber}
        </div>
      </div>
    )
  )
}
